/*
 * (C) 2025 BeyondDemise, All Rights Reserved.
 *
 * TdNodata — empty-state for the dashboard's story list. Single
 * affordance ("Get Started") that hands the click to `loadStory` so the
 * new-story form mounts in the main slot. Pure static template; no
 * server data flows in.
 */

import { LitElement, html, type TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { loadStory } from '../services/story.js';
import { t, LocaleController } from '../services/i18n.js';

@customElement('td-nodata')
export class TdNodata extends LitElement {
  /** Re-renders this component when the UI locale changes (#89). */
  readonly localeController = new LocaleController(this);

  override createRenderRoot(): HTMLElement {
    return this;
  }

  private _handleClick = (event: Event): void => {
    event.preventDefault();
    const target = document.querySelector<HTMLElement>('#main-insertion-point');
    if (!target) return;
    // `wa-button` is a custom element; cast matches the vanilla
    // version's `querySelector<HTMLButtonElement>` lie — `loadStory`
    // only reads `.disabled` from this argument.
    void loadStory(target, event.currentTarget as HTMLButtonElement);
  };

  override render(): TemplateResult {
    return html`
      <section id="nodisclosurelist">
        <!-- Plain container, not a link: an <a href=""> wrapping the
             button nested two interactive controls (keyboard-activating
             the link reloaded the page) — the button is the single
             affordance (#243). -->
        <div
          class="nodata-placeholder wa-stack wa-align-items-center wa-placeholder"
        >
          <wa-icon name="star" class="wa-caption-l"></wa-icon>
          <p class="wa-heading-m">${t('nodata.empty')}</p>
          <p>
            <wa-button
              appearance="filled outlined"
              variant="primary"
              @click=${this._handleClick}
            >
              ${t('nodata.getStarted')}
            </wa-button>
          </p>
        </div>
      </section>
    `;
  }
}
